/** Reveal the contact swirl once, when its background enters the viewport. */
function initContactBackground() {
  const background = document.querySelector(".contact__background");

  if (!background) return;

  // pages/_contact.scss clips the swirl away from the first paint, so it is
  // never seen before the reveal starts. The cost is that this file owns the
  // only way back — a browser with no observer to watch with has to be handed
  // the artwork rather than left looking at nothing.
  if (typeof IntersectionObserver === "undefined") {
    background.classList.add("is-revealed");
    return;
  }

  // Reduced motion is answered in the stylesheet, which leaves the swirl
  // unclipped: there is nothing hidden to reveal and nothing to animate.
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        setTimeout(() => {
          entry.target.classList.add("is-revealed");
        }, 200);

        observer.disconnect();
      });
    },
    { threshold: 0.15 },
  );

  observer.observe(background);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initContactBackground, {
    once: true,
  });
} else {
  initContactBackground();
}
